/**
 * Ojal 3D Orange Brand Ball - Interactive Physics & Autonomous Floating Engine
 * Pure Vanilla JS, high performance (60fps requestAnimationFrame), zero dependencies.
 */
(function () {
  'use strict';

  // Cancel previous loop if reloaded by Shopify Theme Editor or HMR
  if (window.__ojalBrandBallFrameId) {
    try {
      cancelAnimationFrame(window.__ojalBrandBallFrameId);
    } catch (_) {}
  }

  function initOjalBrandBall() {
    const root = document.getElementById('ojal-brand-ball-viewport');
    const ballWrapper = document.getElementById('ojal-brand-ball');
    const ballInner = ballWrapper ? ballWrapper.querySelector('.ojal-brand-ball') : null;
    const minimizeBtn = document.getElementById('ojal-ball-minimize');
    const canvas = document.getElementById('ojal-ball-trail-canvas');

    if (!root || !ballWrapper || !ballInner) return;

    const ctx = canvas ? canvas.getContext('2d') : null;

    // Viewport dimensions & bounds
    let vw = window.innerWidth || document.documentElement.clientWidth || 375;
    let vh = window.innerHeight || document.documentElement.clientHeight || 667;
    let diameter = vw <= 767 ? 62 : 78;

    function updateDimensions() {
      vw = window.innerWidth || document.documentElement.clientWidth || 375;
      vh = window.innerHeight || document.documentElement.clientHeight || 667;
      diameter = vw <= 767 ? 62 : 78;
      if (canvas && ctx) {
        canvas.width = vw;
        canvas.height = vh;
      }
    }

    updateDimensions();
    window.addEventListener('resize', updateDimensions, { passive: true });

    // Initial position: nicely floating on middle-right of the viewport
    let x = Math.max(15, vw - diameter - 45);
    let y = Math.max(15, vh * 0.32);

    // Immediately place ball on screen
    ballWrapper.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px, 0)';

    // Continuous autonomous travel speed across whole section (1.85 px/frame ≈ 110 px/sec)
    const AUTO_CRUISE_SPEED = 1.85;
    let idleAngle = Math.random() * Math.PI * 2;
    let vx = Math.cos(idleAngle) * AUTO_CRUISE_SPEED;
    let vy = Math.sin(idleAngle) * AUTO_CRUISE_SPEED;

    // State machine: 'idle' (active continuous wandering), 'dragging', 'thrown', 'docked'
    let state = 'idle';
    let isMinimized = false;
    
    // Global pause state via body class & prefers-reduced-motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion && !document.body.classList.contains('dewie-motion-off')) {
      document.body.classList.add('dewie-motion-off');
    }

    function getIsPaused() {
      return document.body.classList.contains('dewie-motion-off');
    }
    
    // Bubble Prompt state
    const bubbleTexts = [
      "psst… click me",
      "hi, i’m dewie 👋",
      "wanna play?",
      "click me, i dare you"
    ];
    let bubbleIndex = 0;
    const bubbleEl = ballWrapper.querySelector('.ojal-brand-ball-bubble');
    let bubbleTimeout = null;

    function showBubble() {
      if (!bubbleEl) return;
      
      // Show the message
      bubbleEl.textContent = bubbleTexts[bubbleIndex];
      bubbleEl.classList.add('is-visible');
      bubbleIndex = (bubbleIndex + 1) % bubbleTexts.length;
      
      if (bubbleTimeout) clearTimeout(bubbleTimeout);
      
      // Show for exactly 2 seconds, then hide
      bubbleTimeout = setTimeout(function() {
        bubbleEl.classList.remove('is-visible');
      }, 2000);
    }

    // Gap of 7 seconds + 2 seconds visible = 9 seconds total cycle
    setInterval(function() {
      if ((state === 'idle' || state === 'docked') && document.visibilityState === 'visible') {
        showBubble();
      }
    }, 9000);

    let hoverPauseUntil = 0;
    ballWrapper.addEventListener('pointerenter', function () {
      hoverPauseUntil = performance.now() + 3000;
    });

    // Physics parameters
    const AIR_FRICTION = 0.985;
    const RESTITUTION = 0.82; // Lively bounce on walls
    const MAX_SPEED = 32;     // Prevent clipping on fast flings
    let idleTime = 0;

    // Dragging state tracking
    let pointerId = null;
    let dragOffsetX = 0;
    let dragOffsetY = 0;
    let pointerHistory = [];
    let dragStartX = 0;
    let dragStartY = 0;
    let dragStartTime = 0;

    // Squash and stretch deformation state
    let squashScaleX = 1;
    let squashScaleY = 1;
    let squashVelocityX = 0;
    let squashVelocityY = 0;

    // Trail particles array
    const particles = [];

    function triggerSquash(scaleX, scaleY) {
      squashScaleX = scaleX;
      squashScaleY = scaleY;
    }

    // Spawn subtle glowing particle for fling trails
    function spawnParticle(px, py, speed) {
      if (!ctx || particles.length > 25) return;
      particles.push({
        x: px + diameter / 2 + (Math.random() - 0.5) * 10,
        y: py + diameter / 2 + (Math.random() - 0.5) * 10,
        radius: Math.min(diameter * 0.35, 4 + speed * 0.5),
        alpha: 0.55,
        decay: 0.03 + Math.random() * 0.02
      });
    }

    // Unified Pointer Events on ballWrapper
    ballWrapper.addEventListener('pointerdown', function (e) {
      // Ignore click if it came from minimize button
      if (e.target === minimizeBtn || (minimizeBtn && minimizeBtn.contains(e.target))) {
        return;
      }

      e.preventDefault();
      pointerId = e.pointerId;
      try {
        ballWrapper.setPointerCapture(pointerId);
      } catch (_) {}

      if (state === 'docked') {
        // Un-dock
        state = 'thrown';
        ballWrapper.classList.remove('is-docked');
        vy = -6;
        vx = (Math.random() - 0.5) * 4 - 2; // slight left throw
        triggerSquash(0.85, 1.25);
        showBubble();
        return;
      }

      state = 'dragging';
      ballWrapper.classList.add('is-dragging');
      showBubble();

      dragOffsetX = e.clientX - x;
      dragOffsetY = e.clientY - y;
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      dragStartTime = performance.now();

      pointerHistory = [{ x: e.clientX, y: e.clientY, time: dragStartTime }];
      vx = 0;
      vy = 0;
      triggerSquash(1.08, 0.94);
    });

    ballWrapper.addEventListener('pointermove', function (e) {
      if (state !== 'dragging' || e.pointerId !== pointerId) return;

      const newX = e.clientX - dragOffsetX;
      const newY = e.clientY - dragOffsetY;

      // Soft clamp inside viewport bounds
      x = Math.max(-diameter * 0.2, Math.min(vw - diameter * 0.8, newX));
      y = Math.max(-diameter * 0.2, Math.min(vh - diameter * 0.8, newY));

      const now = performance.now();
      pointerHistory.push({ x: e.clientX, y: e.clientY, time: now });

      // Keep only recent 80ms of pointer history
      while (pointerHistory.length > 1 && now - pointerHistory[0].time > 80) {
        pointerHistory.shift();
      }

      // Spawn trail if dragged fast
      const distMoved = Math.hypot(e.clientX - dragStartX, e.clientY - dragStartY);
      if (distMoved > 10) {
        spawnParticle(x, y, 4);
      }
    });

    function finishDrag(e) {
      if (state !== 'dragging' || (pointerId !== null && e.pointerId !== pointerId)) return;

      try {
        if (pointerId !== null) ballWrapper.releasePointerCapture(pointerId);
      } catch (_) {}
      pointerId = null;
      ballWrapper.classList.remove('is-dragging');

      const now = performance.now();
      const totalDist = Math.hypot(e.clientX - dragStartX, e.clientY - dragStartY);
      const totalTime = now - dragStartTime;

      // Check if this was a simple click/tap without drag
      if (totalDist < 6 && totalTime < 350) {
        // Playful squish hop
        triggerSquash(0.85, 1.25);
        vy = -4.5;
        vx = (Math.random() - 0.5) * 3;
        state = 'thrown';
        return;
      }

      // Compute throw velocity from recent pointer history
      if (pointerHistory.length >= 2) {
        const oldest = pointerHistory[0];
        const latest = pointerHistory[pointerHistory.length - 1];
        const dt = Math.max(10, latest.time - oldest.time);

        // Normalize to px per 16.6ms frame
        const frameRatio = 16.67 / dt;
        vx = (latest.x - oldest.x) * frameRatio * 0.85;
        vy = (latest.y - oldest.y) * frameRatio * 0.85;

        // Cap speed
        const speed = Math.hypot(vx, vy);
        if (speed > MAX_SPEED) {
          vx = (vx / speed) * MAX_SPEED;
          vy = (vy / speed) * MAX_SPEED;
        }

        if (speed > AUTO_CRUISE_SPEED * 1.2) {
          state = 'thrown';
          triggerSquash(1.15, 0.88);
        } else {
          // Immediately roam across the screen
          state = 'idle';
          idleAngle = Math.atan2(vy || Math.random() - 0.5, vx || Math.random() - 0.5);
          vx = Math.cos(idleAngle) * AUTO_CRUISE_SPEED;
          vy = Math.sin(idleAngle) * AUTO_CRUISE_SPEED;
        }
      } else {
        state = 'idle';
        idleAngle = Math.random() * Math.PI * 2;
        vx = Math.cos(idleAngle) * AUTO_CRUISE_SPEED;
        vy = Math.sin(idleAngle) * AUTO_CRUISE_SPEED;
      }
    }

    ballWrapper.addEventListener('pointerup', finishDrag);
    ballWrapper.addEventListener('pointercancel', finishDrag);

    // Double click to reset / dock
    ballWrapper.addEventListener('dblclick', function (e) {
      e.stopPropagation();
      dockBall();
    });

    // Minimize button click
    if (minimizeBtn) {
      minimizeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        dockBall();
      });
    }

    // Dock ball directly above the go-to-top button area
    function dockBall() {
      state = 'docked';
      ballWrapper.classList.add('is-docked');
      // Ensure bubble is shown to prompt user
      showBubble();
    }

    // Scroll coupling: Page scroll adds subtle vertical nudge
    let lastScrollY = window.scrollY || window.pageYOffset;
    window.addEventListener(
      'scroll',
      function () {
        const currentScrollY = window.scrollY || window.pageYOffset;
        const delta = currentScrollY - lastScrollY;
        lastScrollY = currentScrollY;

        if (state === 'idle' || state === 'thrown') {
          vy -= Math.max(-5, Math.min(5, delta * 0.05));
        }
      },
      { passive: true }
    );

    // Main 60fps Physics & Render Loop
    let lastFrameTime = performance.now();
    let isTabVisible = true;

    document.addEventListener('visibilitychange', function () {
      isTabVisible = !document.hidden;
      if (isTabVisible) {
        lastFrameTime = performance.now();
      }
    });

    function physicsLoop(timestamp) {
      window.__ojalBrandBallFrameId = requestAnimationFrame(physicsLoop);

      if (!isTabVisible) return;

      if (!timestamp) timestamp = performance.now();
      const elapsed = timestamp - lastFrameTime;
      lastFrameTime = timestamp;
      const dt = Math.max(4, Math.min(32, elapsed));
      const step = dt / 16.67;

      const maxX = vw - diameter;
      const maxY = vh - diameter;

      // Squash spring physics
      const springK = 0.18;
      const springDamp = 0.72;

      squashVelocityX += (1 - squashScaleX) * springK;
      squashVelocityX *= springDamp;
      squashScaleX += squashVelocityX;

      squashVelocityY += (1 - squashScaleY) * springK;
      squashVelocityY *= springDamp;
      squashScaleY += squashVelocityY;

      // Handle States
      if (state === 'thrown') {
        x += vx * step;
        y += vy * step;

        vx *= Math.pow(AIR_FRICTION, step);
        vy *= Math.pow(AIR_FRICTION, step);

        const currentSpeed = Math.hypot(vx, vy);

        if (currentSpeed > 5) {
          spawnParticle(x, y, currentSpeed);
        }

        // Left / Right Bounce
        if (x <= 0) {
          x = 0;
          vx = -vx * RESTITUTION;
          triggerSquash(0.72, 1.25);
        } else if (x >= maxX) {
          x = maxX;
          vx = -vx * RESTITUTION;
          triggerSquash(0.72, 1.25);
        }

        // Top / Bottom Bounce
        if (y <= 0) {
          y = 0;
          vy = -vy * RESTITUTION;
          triggerSquash(1.25, 0.72);
        } else if (y >= maxY) {
          y = maxY;
          vy = -vy * RESTITUTION;
          triggerSquash(1.25, 0.72);
        }

        // Transition seamlessly to autonomous roaming when throw speed slows to cruise speed
        if (currentSpeed <= AUTO_CRUISE_SPEED) {
          state = 'idle';
          idleAngle = Math.atan2(vy, vx);
          if (isNaN(idleAngle)) idleAngle = Math.random() * Math.PI * 2;
          vx = Math.cos(idleAngle) * AUTO_CRUISE_SPEED;
          vy = Math.sin(idleAngle) * AUTO_CRUISE_SPEED;
        }
      } else if (state === 'idle') {
        const now = performance.now();
        if (getIsPaused()) {
          // Slowly halt if paused
          vx *= 0.9;
          vy *= 0.9;
          
          x += vx * step;
          y += vy * step;
        } else if (now < hoverPauseUntil) {
          // Pause movement on hover for 3 seconds
          vx *= 0.9;
          vy *= 0.9;
          
          x += vx * step;
          y += vy * step;
        } else {
          // Continuous autonomous travel across the entire section / screen
          idleTime += 0.015 * step;
  
          // Organic curve so it travels through different angles and traverses all sections
          idleAngle += (Math.sin(idleTime * 0.5) * 0.015 + (Math.random() - 0.5) * 0.01) * step;
  
          vx = Math.cos(idleAngle) * AUTO_CRUISE_SPEED;
          vy = Math.sin(idleAngle) * AUTO_CRUISE_SPEED;
  
          x += vx * step;
          y += vy * step;
        }

        // Viewport edge reflections: keeps moving and bouncing across the entire screen
        if (x <= 0) {
          x = 0;
          vx = Math.abs(vx);
          idleAngle = Math.atan2(vy, vx);
          triggerSquash(0.85, 1.15);
        } else if (x >= maxX) {
          x = maxX;
          vx = -Math.abs(vx);
          idleAngle = Math.atan2(vy, vx);
          triggerSquash(0.85, 1.15);
        }

        if (y <= 0) {
          y = 0;
          vy = Math.abs(vy);
          idleAngle = Math.atan2(vy, vx);
          triggerSquash(1.15, 0.85);
        } else if (y >= maxY) {
          y = maxY;
          vy = -Math.abs(vy);
          idleAngle = Math.atan2(vy, vx);
          triggerSquash(1.15, 0.85);
        }
      } else if (state === 'docked') {
        // Move smoothly to dock position (bottom right, above go-to-top button)
        const targetX = maxX - 16;
        const targetY = maxY - 90; // Adjust for go-to-top button offset
        
        // Spring physics towards target
        x += (targetX - x) * 0.15 * step;
        y += (targetY - y) * 0.15 * step;
        
        // Dampen velocity
        vx *= 0.5;
        vy *= 0.5;
      }

      // Hard clamp safely within screen bounds
      x = Math.max(0, Math.min(maxX, x));
      y = Math.max(0, Math.min(maxY, y));

      // Apply GPU-accelerated translate3d and squash matrix
      ballWrapper.style.transform =
        'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px, 0) ' +
        'scale(' + squashScaleX.toFixed(3) + ',' + squashScaleY.toFixed(3) + ')';

      // Render particle trail on canvas
      if (ctx && particles.length > 0) {
        ctx.clearRect(0, 0, vw, vh);
        for (let i = particles.length - 1; i >= 0; i--) {
          const p = particles[i];
          p.alpha -= p.decay * step;
          p.radius *= Math.pow(0.96, step);

          if (p.alpha <= 0.01 || p.radius <= 0.5) {
            particles.splice(i, 1);
            continue;
          }

          ctx.save();
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(243, 112, 33, ' + p.alpha.toFixed(3) + ')';
          ctx.shadowColor = 'rgba(255, 140, 40, 0.8)';
          ctx.shadowBlur = 8;
          ctx.fill();
          ctx.restore();
        }
      } else if (ctx) {
        ctx.clearRect(0, 0, vw, vh);
      }
    }

    // Start loop
    window.__ojalBrandBallFrameId = requestAnimationFrame(physicsLoop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOjalBrandBall);
    window.addEventListener('load', initOjalBrandBall);
  } else {
    initOjalBrandBall();
  }

  document.addEventListener('shopify:section:load', initOjalBrandBall);
})();
